const SERVICES = [
  { num: "01", title: "Aluminium\nFabrication", desc: "Windows, doors, shopfronts, pantry cupboards, roller doors & custom structural profiles." },
  { num: "02", title: "Cladding &\nCeilings",   desc: "Exterior facades, signage walls, weatherproof ACP assemblies & all ceiling types." },
  { num: "03", title: "Partitions &\nIron Work", desc: "Office fit-outs, demountable dividers & structural iron fabrication." },
  { num: "04", title: "Glass\nWork",             desc: "Tempered & toughened glazing, balustrades, curtain walls & skylights." },
];

const STATS = [
  ["// Established",       "2004"],
  ["// Years active",      "22 yrs"],
  ["// Projects delivered","500+"],
  ["// Sectors",           "Gov · Private"],
];

export default function About() {
  return (
    <section id="about" style={{ padding: "120px 0", borderBottom: "1px solid var(--ink)" }}>
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 32px" }}>
        <div
          className="about-grid"
          style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: "80px" }}
        >
          {/* Left — heading + services grid */}
          <div>
            <div className="section-tag">// About — No. 02</div>
            <h2 style={{ fontSize: "clamp(40px, 4.5vw, 64px)", lineHeight: 0.98, letterSpacing: "-0.025em", fontWeight: 500, marginTop: "12px" }}>
              Twenty-two years<br />
              of{" "}
              <span style={{ fontWeight: 400, color: "var(--blue)" }}>trusted</span>
              <br />
              aluminium work.
            </h2>

            <div className="section-tag" id="services" style={{ marginTop: "36px" }}>Services — No. 03</div>
            <div style={{ marginTop: "16px", display: "grid", gridTemplateColumns: "1fr 1fr", border: "1px solid var(--ink)" }}>
              {SERVICES.map((s, i) => (
                <div
                  key={s.num}
                  className="service-card"
                  style={{
                    padding: "28px",
                    borderRight: i % 2 === 0 ? "1px solid var(--ink)" : "none",
                    borderBottom: i < 2 ? "1px solid var(--ink)" : "none",
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--muted)", display: "flex", justifyContent: "space-between", alignItems: "center" }} className="svc-meta">
                    <span style={{ color: "var(--blue)" }}>{s.num}</span>
                    <span className="svc-sym" style={{ color: "var(--blue)" }}>◆</span>
                  </div>
                  <h4 style={{ fontSize: "22px", fontWeight: 500, letterSpacing: "-0.01em", lineHeight: 1.15, whiteSpace: "pre-line" }}>{s.title}</h4>
                  <p style={{ fontSize: "13px", lineHeight: 1.5, color: "var(--muted)" }}>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — body text + stats */}
          <div>
            <div style={{ fontSize: "17px", lineHeight: 1.55, color: "#222", marginTop: "28px" }}>
              <p>
                Founded in <strong>2004</strong> and based in Maharagama, Hatharasinghe Enterprises has spent over two decades delivering aluminium construction, cladding and glasswork across Sri Lanka, for both the government and the private sector.
              </p>
              <p style={{ marginTop: "18px" }}>
                Our work covers the full scope of a modern building envelope: aluminium windows, doors and shopfronts; tempered and structural glazing; composite cladding and all ceiling types; office partitions; pantry cupboards; roller doors; and iron fabrication.
              </p>
              <p style={{ marginTop: "18px" }}>
                From single-door residential fit-outs to multi-storey curtain walls for ministries, schools and banks, the same team, the same standard.
              </p>
            </div>

            {/* Stats grid */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderTop: "1px solid var(--ink)", borderLeft: "1px solid var(--ink)", marginTop: "48px" }}>
              {STATS.map(([k, v]) => (
                <div key={k} style={{ padding: "28px 20px", borderRight: "1px solid var(--ink)", borderBottom: "1px solid var(--ink)" }}>
                  <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--muted)" }}>{k}</div>
                  <div style={{ fontSize: "44px", fontWeight: 500, letterSpacing: "-0.02em", marginTop: "6px" }}>{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
